import { createRouter, createWebHistory } from 'vue-router'
import store from '../store/store'
import Swal from "sweetalert2";

const router = createRouter({
  history: createWebHistory(),
  // ✅ ใหม่ — รองรับ scroll ไปยัง element ตาม #hash ใน URL (ใช้ตอน redirect ไปหน้าตั้งค่าเพจพร้อม
  // #ig-connect-card ให้ scroll ไปโชว์การ์ดเชื่อมต่อ Instagram ทันที — ดู DashboardHomeScreen.vue/
  // ManagerChatScreen.vue/ManagerCommentScreen.vue: ปุ่ม toggle IG ตอนยังไม่เชื่อมต่อบัญชี)
  scrollBehavior(to) {
    if (to.hash) {
      return { el: to.hash, behavior: "smooth", top: 80 };
    }
    return { top: 0 };
  },
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('../views/LoginScreen.vue'),
      meta: { requiresAuth: false, title: 'เข้าสู่ระบบ — Pagerunway' },
    },
    {
      path: '/logout',
      name: 'logout',
      component: () => import('../views/LogoutScreen.vue'),
      meta: { requiresAuth: false, title: 'Pagerunway' },
    },
    {
      path: '/',
      name: 'home',
      component: () => import('../views/HomeScreen.vue'),
      meta: { requiresAuth: true, title: 'หน้าหลัก — Pagerunway' },
    },
    {
      path: '/terms',
      name: 'terms',
      component: () => import('../views/LegalView.vue'),
      meta: { requiresAuth: false, title: 'เงื่อนไขการให้บริการ — Pagerunway' }
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: () => import('../views/LegalView.vue'),
      meta: { requiresAuth: false, title: 'นโยบายความเป็นส่วนตัว — Pagerunway' }
    },
    {
      // ✅ ใหม่ — redirect URI ของ Business Login for Instagram (ต้องตั้งค่าให้ตรงกับ
      // INSTAGRAM_REDIRECT_URI ฝั่ง backend และ App Dashboard ของแอป Pagerunway-IG เป๊ะๆ)
      path: '/instagram/callback',
      name: 'instagram-callback',
      component: () => import('../views/InstagramCallbackScreen.vue'),
      meta: { requiresAuth: true, title: 'กำลังเชื่อมต่อ Instagram — Pagerunway' },
    },
    {
      path: '/dashboard/:id',
      component: () => import('../views/DashboardLayout.vue'),
      meta: { requiresAuth: true },
      children: [
        {
          path: '',
           name: 'pages',
          redirect: (to) => ({ name: 'dashboard-home', params: to.params }),
        },
        {
          path: 'home',
          name: 'dashboard-home',
          component: () => import('../views/DashboardHomeScreen.vue'),
          meta: { title: 'Console — Pagerunway' },
        },
        {
          path: 'page/setting',
          name: 'page-setting',
          component: () => import('../views/PageSettingScreen.vue'),
          meta: { requiresAuth: true, bypassBusinessCheck: true, title: 'ตั้งค่าเพจ — Pagerunway' },
        },
        {
          path: 'post',
          name: 'dashboard-post',
          component: () => import('../views/ManagerPostScreen.vue'),
          meta: { title: 'จัดการโพสต์ — Pagerunway' },
        },
        {
          path: 'ads',
          name: 'dashboard-ads',
          component: () => import('../views/AiAd/AdsScreen.vue'),
          meta: { title: 'จัดการโฆษณา — Pagerunway' },
        },
        {
          path: 'ads/setting/:id',
          name: 'dashboard-ads-setting',
          component: () => import('../views/AiAd/AdSetting.vue'),
          meta: { title: 'ตั้งค่าโฆษณา — Pagerunway' },
        },
        {
          path: 'ads/ai-generator',
          name: 'dashboard-ads-ai-ad',
          component: () => import('../views/AiAd/AIAdGenerate.vue'),
          meta: { title: 'สร้างโฆษณาด้วย AI — Pagerunway' },
        },
        {
          path: 'package',
          name: 'dashboard-package',
          component: () => import('../views/PackageScreen.vue'),
          meta: { title: 'แพ็กเกจ — Pagerunway' },
        },
        {
          path: 'package/checkout/:id',
          name: 'dashboard-package-checkout',
          component: () => import('../views/PackageCheckoutMethodScreen.vue'),
          meta: { title: 'ชำระเงิน — Pagerunway' },
        },
        {
          path: 'chat',
          name: 'dashboard-chat',
          component: () => import('../views/ManagerChatScreen.vue'),
          meta: { title: 'แชท — Pagerunway' },
        },
        {
          path: 'comment',
          name: 'dashboard-comment',
          component: () => import('../views/ManagerCommentScreen.vue'),
          meta: { title: 'คอมเมนต์ — Pagerunway' },
        },
        {
          // ✅ ใหม่ — Instagram Comment Moderation (instagram_business_manage_comments / App Review)
          path: 'instagram-comments',
          name: 'dashboard-instagram-comments',
          component: () => import('../views/InstagramCommentsScreen.vue'),
          meta: { title: 'Instagram comments — Pagerunway' },
        },
        {
          path: 'health',
          name: 'dashboard-health',
          component: () => import('../views/ManagerPageHealth.vue'),
          meta: { title: 'สุขภาพเพจ — Pagerunway' },
        },
        {
          path: 'schedule',
          name: 'dashboard-schedule',
          component: () => import('../views/PostScheduleScreen.vue'),
          meta: { title: 'ตารางโพสต์ — Pagerunway' },
        },
        {
          // ✅ ใหม่ — จัดการระบบสั่งอาหาร/สินค้าหน้าร้าน (dine-in) — ดู views/DineInScreen.vue
          path: 'dine-in',
          name: 'dashboard-dine-in',
          component: () => import('../views/DineInScreen.vue'),
          meta: { title: 'สั่งหน้าร้าน — Pagerunway' },
        },
        {
          // ✅ ใหม่ — หน้าจัดการสต๊อกแยกจากหน้าแก้ไขสินค้า (StockScreen.vue) — ดู views/InventoryScreen.vue
          path: 'inventory',
          name: 'dashboard-inventory',
          component: () => import('../views/InventoryScreen.vue'),
          meta: { title: 'จัดการสต๊อก — Pagerunway' },
        },
        {
          path: 'stock',
          name: 'dashboard-stock',
          component: () => import('../views/StockScreen.vue'),
          meta: { title: 'สต็อก — Pagerunway' },
        },
        {
          path: 'order',
          name: 'dashboard-order',
          component: () => import('../views/OrderScreen.vue'),
          meta: { title: 'ออเดอร์ — Pagerunway' },
        },
        {
          // ✅ ใหม่ — หน้าแยกสำหรับ "ออเดอร์ใหม่ที่ต้องดำเนินการ" (เดิมอยู่ใน DashboardHomeScreen.vue
          // เต็มหน้า ไม่มี pagination) — ดู views/PendingOrdersScreen.vue
          path: 'pending-orders',
          name: 'dashboard-pending-orders',
          component: () => import('../views/PendingOrdersScreen.vue'),
          meta: { title: 'ออเดอร์ที่ต้องดำเนินการ — Pagerunway' },
        },
        {
          // ✅ ใหม่ — ฐานข้อมูลลูกค้าที่ซื้อสินค้า — ดู views/CustomersScreen.vue
          path: 'customers',
          name: 'dashboard-customers',
          component: () => import('../views/CustomersScreen.vue'),
          meta: { title: 'ลูกค้า — Pagerunway' },
        },
        {
          // ✅ ใหม่ — หน้ารายได้รวมจากการขาย แยกตามช่องทางชำระเงิน — ดู views/RevenueScreen.vue
          path: 'revenue',
          name: 'dashboard-revenue',
          component: () => import('../views/RevenueScreen.vue'),
          meta: { title: 'รายได้รวม — Pagerunway' },
        },
        {
          // ✅ ใหม่ — คู่มือการใช้งาน (เนื้อหาอยู่ที่ src/guide/guideContent.js) slug ว่าง = หน้ารายการบทความ
          path: 'guide/:slug?',
          name: 'dashboard-guide',
          component: () => import('../views/GuideScreen.vue'),
          meta: { title: 'คู่มือการใช้งาน — Pagerunway' },
        },
        {
          path: 'logs',
          name: 'dashboard-logs',
          component: () => import('../views/UsageLogsScreen.vue'),
          meta: { title: 'ประวัติการใช้งาน — Pagerunway' },
        },
      ]
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('../views/RegisterScreen.vue'),
      meta: { requiresAuth: false, title: 'สมัครสมาชิก — Pagerunway' },
    },
    {
      path: '/start',
      name: 'start',
      component: () => import('../views/StartScreen.vue'),
      meta: { requiresAuth: true, title: 'เริ่มต้นใช้งาน — Pagerunway' },
    },
  ]
})

// ✅ SEO: เปลี่ยน document.title ตาม route meta
router.afterEach((to) => {
  const title = to.meta?.title
  if (title) {
    document.title = title
  }
})

// Navigation Guard
router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters.getToken

  if (to.name === 'login' && isAuthenticated) {
    return next('/')
  }

  if (to.meta.requiresAuth === true && !isAuthenticated) {
    return next('/login')
  }

  next()
})

router.beforeEach(async (to, from, next) => {
  if (['terms', 'privacy', 'login', 'register'].includes(to.name)) {
    return next()
  }

  if (!window.hasUnsavedContent) {
    return next()
  }

  const result = await Swal.fire({
    title: "คุณแน่ใจหรือไม่?",
    text: "คอนเทนต์ที่กำลังทำจะหายไป ต้องการออกจากหน้านี้หรือไม่?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "ออกจากหน้านี้",
    cancelButtonText: "อยู่ต่อ"
  });

  if (result.isConfirmed) {
    window.hasUnsavedContent = false;
    next();
  } else {
    next(false);
  }
});

export default router